export const SIDEBAR_SEARCH_STYLE = {
  paddingTop: 0,
  paddingBottom: 0,
};
